import React, {Component} from 'react';
import './styles.scss';
import CardHelper from '../../helpers';
import Asset from 'src/requests/apa/Asset';

class CardView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showActions: props.showActions
    }
    this.showActions = props.showActions;
    this.cover = props.cover;
    this.bookmark = props.bookmark;
    this.badges = props.badges;
    this.showTitles = props.showTitles;
    this.title = props.title;
    this.isRecentActivity = props.isRecentActivity;
    this.onDeleteAction = props.onDeleteAction;
    this.data = props.data;
    this.id = props.id;
    this.isChannelBlocked = props.isChannelBlocked;
  }

  componentWillUpdate(nextProps){
    if(nextProps.showActions !== this.state.showActions){
      this.setState({showActions: nextProps.showActions});
    }
  }

  render() {

    const {provider = '', live_enabled = "0"} = this.data;
    const isTitleEnabled = CardHelper.posterTitleIsEnabled(provider);
    const viewFooter = this.isRecentActivity && this.state.showActions
    const stylesWithFooter = viewFooter ? {height: '200px'} : {};

    const iconBlocked = Asset.get('Metadata_ContenidoBloqueado_IconoBloqueado');
    const imageWithTransparency = Asset.get('Metadata_ContenidoBloqueado_Transparencia');
    const existsiconBlocked = iconBlocked !== 'Metadata_ContenidoBloqueado_IconoBloqueado';
    const existsImageWithTransparency = imageWithTransparency !== 'Metadata_ContenidoBloqueado_Transparencia';
    

    return (
      <div className={'card card-view'} style={stylesWithFooter}>
        <div className={`card-container  ${this.props.classOutLineFocus}`}>
          {
            this.isChannelBlocked && existsiconBlocked &&
            (
              <div>
                <div
                  className='card-cover-overlay'
                  style={{ backgroundImage: `url(${this.isChannelBlocked && existsImageWithTransparency ? imageWithTransparency : null})` }}
                />
                <img className='icon-channel-blocked' 
                  src={iconBlocked}
                />
              </div>
            )
          }
          <div className={'preview-container'}>
            {
              this.cover !== '' &&
              <div
                className='card-cover'
                style={{ backgroundImage: `url(${this.cover})` }}
              />
            }
            {CardHelper.createProgressBar(this.bookmark)}
            {CardHelper.createBadge(this.badges)}
          </div>
          {CardHelper.createTitle(this.title, isTitleEnabled, live_enabled === "1")}
        </div>
        <div className='card-labels-container'>
          { CardHelper.createFooter( this.isRecentActivity, this.state.showActions)}
        </div>
      </div>
    );
  }
}

export default CardView;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardView/index.js